import { combineEpics } from 'redux-observable';
import familyEpic from './familyEpic';

export default combineEpics(familyEpic);
